
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.628 3.368h-.006a.365.365 0 00-.038.729l.154.018c.659.078.837.1 1.73.233.22.44.49.988.77 1.562l-1.761 3.174a1 1 0 01-.875.515H10.94l.721-2.068c.073-.244.059-.732-.585-.732H6.36c-.176.005-.513.105-.454.468-1.816.835-1.933 3.324-1.904 3.455.014.06.693.066 1.474.053a1.89 1.89 0 103.769-.07h4.312a.5.5 0 00.41-.215l2.056-2.954a122.16 122.16 0 01.436.925 3.001 3.001 0 00-1.116 1.57c-.056.19.076.375.27.409.194.034.376-.098.44-.284a2.287 2.287 0 012.202-1.55c.197.003.382-.124.416-.319.034-.194-.096-.38-.293-.391a3 3 0 00-.862.079 180.598 180.598 0 01-1.425-2.702h.692V4.167h-.79a.55.55 0 00-.388.16c-.125-.245-.239-.47-.337-.666a.513.513 0 00-.463-.293h-.008a45.978 45.978 0 01-2.01.003l-.16-.003zM6.15 10.893c0-.045.002-.09.007-.134.393-.01.77-.024 1.066-.037l.07-.018h1.27a1.214 1.214 0 11-2.412.189zm13.959 0a1.89 1.89 0 11-3.782 0 1.89 1.89 0 013.782 0zm-.677 0a1.213 1.213 0 11-2.427 0 1.213 1.213 0 012.427 0zM6.855 6.603H11.04a.362.362 0 00.026-.724l-4.16-.341a.533.533 0 10-.05 1.065z","fill":"currentColor"}})])
          )
        }
      }
    